(function () {
    'use strict';

    class SiteExplorerLeafletCtrl{
        constructor($scope, swifRouteService, dataService, swifCartoLeafletService, $rootScope, swifFrameworkService, swifPatrimoineReferentielService) {
            this.$scope = $scope;
            this.showLeaflet = false;
            this.route = swifRouteService;
            this.data = dataService;
            this.swifCartoLeafletService = swifCartoLeafletService;
            $rootScope.$on('onClickCurrentItemToOpenPopupMap', this.onClickCurrentItemToOpenPopupMap.bind(this) );
            this.swif = swifFrameworkService;
            this.parentScope = this.$scope.$parent.$parent;
            this.swifPatrimoineReferentielService = swifPatrimoineReferentielService
        }
        $onInit() {
            this.isVSN = this.swif.settings.app.features.isVSN;
            if (!this.type) {
                this.type = this.collection.contentType;
            }
            if (!this.filter) {
                this.filter = this.collection.currentFilter;
            }
            var $ctrl = this;
            this.route.check({resources: ['leaflet']}).then(function() {
                $ctrl.showLeaflet = true;
            });
            this.$scope.$watch('$ctrl.collection.currentFilter', function(newV) {
                $ctrl.filter = newV;
            }, true);
            this.$scope.$watch('$ctrl.collection.lastUpdateDateTime', function() {
                $ctrl.updateMarkers();
            });

            // TG-3474-VSN - get all site_categories to fill selects options
            if ($ctrl.isVSN && $ctrl.collection.contentType == 'patrimoine_site') {
                $ctrl.allLayerCategories, $ctrl.allFamilyCategories, $ctrl.allSites, $ctrl.selectedMarkersList = [];
                $ctrl.getAllSiteCategories('is_layer').then(function(data) {
                    $ctrl.allLayerCategories = data;
                });
                $ctrl.getAllSiteCategories('is_family').then(function(data) {
                    $ctrl.allFamilyCategories = data;
                });

                // Initialize color icons for markers
                $ctrl.blueIcon = L.AwesomeMarkers.icon({
                    icon: 'info',
                    markerColor: 'blue',
                    iconColor: 'white',
                    prefix: 'fa'
                });
                $ctrl.orangeIcon = L.AwesomeMarkers.icon({
                    icon: 'info',
                    markerColor: 'orange',
                    iconColor: 'white',
                    prefix: 'fa'
                });

                // Listen to changes in selected markers list
                this.$scope.$on('markerIsDeselected', function(data, selectedMarkersList, siteID) {
                    if ($ctrl.markerBySiteId[siteID]) {
                        // Marker deselected via sidebar
                        $ctrl.selectedMarkersList = selectedMarkersList;
                        var deselectedMarker = $ctrl.markerBySiteId[siteID];
                        if (deselectedMarker.isPoint){
                            deselectedMarker.setIcon($ctrl.blueIcon);
                        } else {
                            deselectedMarker.setStyle({color: 'blue'})
                        }
                    }
                });
            }
        }
        $onChanges(changesObj) {
            this.updateMarkers();
        }
        onClickCurrentItemToOpenPopupMap(event, data, sites) {
            var $ctrl = this;
            let marker = $ctrl.markerBySiteId[data.id];

            // Get the previous selected site and reset highlights
            // lastSelectedSite can be only a marker cause we add lastSelectedId property only if it is a marker
            var lastSelectedSite = Object.values($ctrl.markerBySiteId).find( site => site.lastSelectedId );

            if(lastSelectedSite) {
                lastSelectedSite.lastSelectedId = false;
                lastSelectedSite.setStyle({color: 'blue'});
                $ctrl.map.closePopup();
            }

            if (marker) {
                // Search and get if the selected site has parent is in the search list
                var parentSiteIsInSearchList = sites.filter(site => site.id == data.site_parent_id[0]);


                // Add the site parent polygon
                // If there is no corresponding parent is the search list but the selected site has parent
                if(_.isEmpty(parentSiteIsInSearchList) && data.site_parent_id) {
                    var filter = { };
                    filter.fields = [
                        'geo_polygon',
                        'state',
                        'name',
                        'street',
                        'street2',
                        'zip',
                        'city',
                        'type_id',
                        'service_names',
                        'site1',
                        'swif_id',
                        'custom_fields'
                    ];
                    $ctrl.swif.data.addFilter(filter, 'id', '=', data.site_parent_id[0]);

                    $ctrl.swif.data.searchRead('patrimoine_site', filter).then(function(site_data) {
                        var cartoService = $ctrl.swifCartoLeafletService;
                        var parentSite = site_data.records[0];
                        let parentGeoPolygon = JSON.parse(parentSite.geo_polygon);

                        if (parentGeoPolygon) {
                            var parentPolygon = cartoService.getMarkerFromPolygon(parentGeoPolygon, {color: 'blue'});
                            var $scope = $ctrl.$scope.$new();
                            $scope.collection = $ctrl.collection;
                            let footer = $ctrl.generateClickablePopupFooter(parentSite.id);
                            var html = cartoService.getPanelHTML(parentSite, $scope, {footer: footer});
                            let detailBtn = html.querySelector(`#detail-${parentSite.id}`)
                            if (detailBtn) {
                                detailBtn.addEventListener("click", () => $ctrl.getDetails(parentSite, parentPolygon))
                            }
                            let selectBtn = html.querySelector(`#select-${parentSite.id}`)
                            if (selectBtn) {
                                selectBtn.addEventListener("click", () => $ctrl.selectPolygon(parentSite))
                            }
                            parentPolygon.bindPopup(html);

                            var layerToAdd = L.featureGroup([parentPolygon]);
                            layerToAdd.addTo($ctrl.map).bringToBack()
                            marker.lastSelectedLayer = layerToAdd;
                        }
                    });
                }

                if (!marker.isPoint) {
                    marker.setStyle({color: 'orange'})
                    marker.isSelected = true;
                    marker.lastSelectedId = data.id;
                    $ctrl.map.fitBounds(marker.getBounds());
                } else {
                    $ctrl.map.setView(marker.getLatLng(), 18);
                }
                marker.openPopup();
                $ctrl.onClosePopup(marker);
            }
            // Remove previous added parent polygon before creating new one
            if (lastSelectedSite) {
                console.log('remove previous parent', lastSelectedSite._leaflet_id, data.site_parent_id[0])
                $ctrl.swifCartoLeafletService.removeLayerFromMap(lastSelectedSite.lastSelectedLayer, $ctrl.map)
                lastSelectedSite.lastSelectedLayer = false;
            }
        }
        _onMapInitialized(map) {
            this.map = map;
            this.updateMarkers();
            var height = $('.swif-explorer-left').height();
            $(map._container).height(height);
            map.invalidateSize(true);

            // TG-3637-VSN - Hide tabs when clicking on map
            map.on("click", e => {
                this.$scope.$emit('closeTabs');
            });
        }
        onClosePopup(marker) {
            // Hide tabs when closing marker popup
            let $ctrl = this;
            const popup = marker.isMultiLayers ? marker._map._popup : marker._popup;
            if(popup._isOpen) {
                const closeBtnElem = popup._closeButton;
                closeBtnElem.addEventListener('click',function() {
                    $ctrl.$scope.$emit('closeTabs');
                });
            }
        }
        generateClickablePopupFooter(siteId) {
            return `
            <div class='panel-footer pannel-popup'>
                <div>
                    <a class='col-md-6 btn btn-xs btn-link' id='detail-${siteId}'
                            tooltip='Afficher le détail du site'
                            data-toggle="tooltip" data-placement="bottom" title="Afficher le détail du site">
                        <i class='fa fa-eye fa-lg' />
                    </a>
                    <a class='col-md-6 btn btn-xs btn-link' id='select-${siteId}'
                            tooltip='Afficher les actions'
                            data-toggle="tooltip" data-placement="bottom" title="Afficher les actions">
                        <i class='fa fa-check fa-lg' />
                    </a>
                </div>
            </div>`;
        }
        // TG-3637-VSN - Hide / show tabs from popup
        getDetails(site, marker) {
            let $ctrl = this;
            $ctrl.onClosePopup(marker);

            var filter = {};
            filter.limit = 0;
            filter.fields = [
                'geo_point',
                'geo_multi_point',
                'geo_line',
                'geo_multi_line',
                'geo_polygon',
                'geo_multi_polygon',
                'state',
                'name',
                'street',
                'street2',
                'zip',
                'city',
                'type_id',
                'service_names',
                'site1',
                'swif_id',
                'custom_fields'
            ];
            $ctrl.swif.data.addFilter(filter, 'id', '=', site.id);
            $ctrl.swif.data.searchRead('patrimoine_site', filter).then(function(data) {
                $ctrl.$scope.$emit('onClickDetailSite', data.records[0]);
            });

        }

        updateMarkers(){
            var $ctrl = this;
            $ctrl.markerBySiteId = {};
            var service = $ctrl.swifCartoLeafletService;
            if (!this.showLeaflet || !(this.type && this.filter)) {
                return;
            }

            function getMarker(site) {
                var icon = service.getIconFromSite(site);
                var marker = service.getMarkerFromPoint(site.geo_point, {icon: icon});
                var $scope = $ctrl.$scope.$new();
                $scope.collection = $ctrl.collection;
                var footer = `<a class="btn btn-link"
                    ng-click="collection.setCurrent(proxy.id)">
                </a>`;

                // TG-3474-VSN - change pin modal behavior to prevent thousands of calls to get sites info
                if ($ctrl.isVSN) {
                    var html = service.getVSNPanelHTML(site, $scope);
                    let btnSelect = html.querySelector(`#select-${site.id}`)
                    if(btnSelect){
                        btnSelect.addEventListener("click", (e) => $ctrl.selectMarker(site.id, marker))
                    }

                    let detailBtn = html.querySelector(`#detail-${site.id}`)
                    if(detailBtn){
                        detailBtn.addEventListener("click", (e) => $ctrl.getDetails(site, marker))
                    }
                    marker.bindPopup(html);
                } else {
                    var html = service.getPanelHTML(site, $scope, {footer: footer});
                    marker.bindPopup(html);
                }
                return marker;
            }

            function getLine(site) {
                let geoLine = JSON.parse(site.geo_line)
                var marker = service.getMarkerFromLine(geoLine, {color: 'blue', weight: 10});
                var $scope = $ctrl.$scope.$new();
                $scope.collection = $ctrl.collection;
                var footer = `<a class="btn btn-link"
                    ng-click="collection.setCurrent(proxy.id)">
                </a>`;

                // TG-3474-VSN - change pin modal behavior to prevent thousands of calls to get sites info
                if ($ctrl.isVSN) {
                    var html = service.getVSNPanelHTML(site, $scope);
                    let button = html.querySelector(`#select-${site.id}`)
                    if(button){
                        button.addEventListener("click", (e) => $ctrl.selectLine(site.id, marker))
                    }

                    let detailBtn = html.querySelector(`#detail-${site.id}`)
                    if (detailBtn) {
                        detailBtn.addEventListener("click", () => $ctrl.getDetails(site, marker))
                    }
                    marker.bindPopup(html);
                } else {
                    var html = service.getPanelHTML(site, $scope, {footer: footer});
                    marker.bindPopup(html);
                }
                return marker;
            }

            function getMultiLine(site) {
                let geoMultiLine = JSON.parse(site.geo_multi_line)
                var multiLine = service.getMarkerFromMultiLine(geoMultiLine, {color: 'blue', weight: 10});
                var $scope = $ctrl.$scope.$new();
                $scope.collection = $ctrl.collection;
                var footer = `<a class="btn btn-link"
                    ng-click="collection.setCurrent(proxy.id)">
                </a>`;

                // TG-3474-VSN - change pin modal behavior to prevent thousands of calls to get sites info
                if ($ctrl.isVSN) {
                    var html = service.getVSNPanelHTML(site, $scope);

                    // set detail button of popup
                    let detailBtn = html.querySelector(`#detail-${site.id}`)
                    if (detailBtn) {
                        detailBtn.addEventListener("click", () => $ctrl.getDetails(site, multiLine))
                    }
                    // set select/deselect button of popup
                    let selectBtn = html.querySelector(`#select-${site.id}`)
                    if (selectBtn) {
                        selectBtn.addEventListener("click", () => $ctrl.selectLine(site.id, multiLine))
                    }
                    multiLine.bindPopup(html);
                } else {
                    var html = service.getPanelHTML(site, $scope, {footer: footer});
                    multiLine.bindPopup(html);
                }
                return multiLine;
            }

            function getPolygon(site) {
                let geoPolygon = JSON.parse(site.geo_polygon)
                var polygon = service.getMarkerFromPolygon(geoPolygon, {color: 'blue'});
                var $scope = $ctrl.$scope.$new();
                $scope.collection = $ctrl.collection;
                var footer = `<a class="btn btn-link"
                    ng-click="collection.setCurrent(proxy.id)">
                </a>`;

                // TG-3474-VSN - change pin modal behavior to prevent thousands of calls to get sites info
                if ($ctrl.isVSN) {
                    var html = service.getVSNPanelHTML(site, $scope);
                    // set detail button of popup
                    let detailBtn = html.querySelector(`#detail-${site.id}`)
                    if (detailBtn) {
                        detailBtn.addEventListener("click", () => $ctrl.getDetails(site, polygon))
                    }
                    // set select/deselect button of popup
                    let selectBtn = html.querySelector(`#select-${site.id}`)
                    if (selectBtn) {
                        selectBtn.addEventListener("click", () => $ctrl.selectLine(site.id, polygon))
                    }
                    polygon.bindPopup(html);
                } else {
                    let footer = $ctrl.generateClickablePopupFooter(site.id);
                    var html = service.getPanelHTML(site, $scope, {footer: footer});
                    // set detail button of popup
                    let detailBtn = html.querySelector(`#detail-${site.id}`)
                    if (detailBtn) {
                        detailBtn.addEventListener("click", () => $ctrl.getDetails(site, polygon))
                    }
                    let selectBtn = html.querySelector(`#select-${site.id}`)
                    if (selectBtn) {
                        selectBtn.addEventListener("click", () => $ctrl.selectPolygon(site))
                    }
                    polygon.bindPopup(html);
                }
                return polygon;
            }

            function getMultiPolygon(site) {
                let geoMultiPolygon = JSON.parse(site.geo_multi_polygon)
                var multiPolygon = service.getMarkerFromMultiPolygon(geoMultiPolygon, {color: 'blue'});
                var $scope = $ctrl.$scope.$new();
                $scope.collection = $ctrl.collection;
                var footer = `<a class="btn btn-link"
                    ng-click="collection.setCurrent(proxy.id)">
                </a>`;

                // TG-3474-VSN - change pin modal behavior to prevent thousands of calls to get sites info
                if ($ctrl.isVSN) {
                    var html = service.getVSNPanelHTML(site, $scope);
                    // set detail button of popup
                    let detailBtn = html.querySelector(`#detail-${site.id}`)
                    if (detailBtn) {
                        detailBtn.addEventListener("click", () => $ctrl.getDetails(site, multiPolygon))
                    }
                    // set select/deselect button of popup
                    let selectBtn = html.querySelector(`#select-${site.id}`)
                    if (selectBtn) {
                        selectBtn.addEventListener("click", () => $ctrl.selectLine(site.id, multiPolygon))
                    }
                    multiPolygon.bindPopup(html);
                } else {
                    var html = service.getPanelHTML(site, $scope, {footer: footer});
                    multiPolygon.bindPopup(html);
                }
                return multiPolygon;
            }



            service.removeLayerFromMap($ctrl.layer, $ctrl.map, 'removeAllLayers');

            let markers = [];
            let lines = [];
            let multiLines = [];
            let polygons = [];
            let multiPolygons = [];
            // TG-3474-VSN - iterate over all sites instead of initial collection - unless we are in research mode
            let sitesList = [];
            // If isResearchOn object exists in parent scope, retrieve value of its property "on"
            $ctrl.parentScope.isResearchOn ? $ctrl.isResearchOn = $ctrl.parentScope.isResearchOn.on : $ctrl.isResearchOn = false;
            if ($ctrl.isVSN && !$ctrl.isResearchOn) {
                sitesList = $ctrl.allSites || sitesList;
            } else {
                sitesList = this.collection.items || sitesList;
                $ctrl.allSites = sitesList
            }

            sitesList.forEach(function(site) {
                if(site.geo_line && $ctrl.map) {
                    let line = getLine(site);
                    if (line) {
                        lines.push(line);
                        $ctrl.markerBySiteId[site.id] = line;
                        $ctrl.markerBySiteId[site.id].isPoint = false;
                        $ctrl.markerBySiteId[site.id].isSelected = false;
                    }
                } else if (site.geo_multi_line && $ctrl.map){
                    let multiLine = getMultiLine(site);
                    if (multiLine) {
                        multiLines.push(multiLine);
                        $ctrl.markerBySiteId[site.id] = multiLine;
                        $ctrl.markerBySiteId[site.id].isPoint = false;
                        $ctrl.markerBySiteId[site.id].isSelected = false;
                        $ctrl.markerBySiteId[site.id].isMultiLayers = true;
                    }
                } else if (site.geo_polygon && $ctrl.map){
                    let polygon = getPolygon(site);
                    if (polygon) {
                        polygons.push(polygon);
                        $ctrl.markerBySiteId[site.id] = polygon;
                        $ctrl.markerBySiteId[site.id].isPoint = false;
                        $ctrl.markerBySiteId[site.id].isSelected = false;
                    }
                } else if (site.geo_multi_polygon && $ctrl.map){
                    let multiPolygon = getMultiPolygon(site);
                    if (multiPolygon) {
                        multiPolygons.push(multiPolygon);
                        $ctrl.markerBySiteId[site.id] = multiPolygon;
                        $ctrl.markerBySiteId[site.id].isPoint = false;
                        $ctrl.markerBySiteId[site.id].isSelected = false;
                        $ctrl.markerBySiteId[site.id].isMultiLayers = true;
                    }
                } else if (site.geo_point){
                    let marker = getMarker(site);
                    if (marker) {
                        markers.push(marker);
                        $ctrl.markerBySiteId[site.id] = marker;
                        $ctrl.markerBySiteId[site.id].isPoint = true;
                        $ctrl.markerBySiteId[site.id].isSelected = false;
                    }
                }
            });

            if ($ctrl.map && markers.length > 0) {
                var layerToAdd = L.featureGroup(markers);
                $ctrl.layer = L.markerClusterGroup();
                $ctrl.layer.options.spiderfyOnMaxZoom = false;
                $ctrl.layer.options.disableClusteringAtZoom= 20;
                $ctrl.layer.addLayer(layerToAdd);
                $ctrl.layer.addTo($ctrl.map);
                $ctrl.map.fitBounds($ctrl.layer.getBounds());
            }

            if ($ctrl.map && lines.length > 0) {
                var layerToAdd = L.featureGroup(lines);
                $ctrl.layer = L.markerClusterGroup();
                $ctrl.layer.addLayer(layerToAdd);
                $ctrl.layer.addTo($ctrl.map);
                $ctrl.map.fitBounds($ctrl.layer.getBounds());
            }

            if ($ctrl.map && multiLines.length > 0) {
                var layerToAdd = L.featureGroup(multiLines);
                $ctrl.layer = L.markerClusterGroup();
                $ctrl.layer.addLayer(layerToAdd);
                $ctrl.layer.addTo($ctrl.map);
                $ctrl.map.fitBounds($ctrl.layer.getBounds());
            }

            if ($ctrl.map && polygons.length > 0) {
                var layerToAdd = L.featureGroup(polygons);
                $ctrl.layer = L.markerClusterGroup();
                $ctrl.layer.addLayer(layerToAdd);
                $ctrl.layer.addTo($ctrl.map);
                $ctrl.map.fitBounds($ctrl.layer.getBounds());
            }

            if ($ctrl.map && multiPolygons.length > 0) {
                var layerToAdd = L.featureGroup(multiPolygons);
                $ctrl.layer = L.markerClusterGroup();
                $ctrl.layer.addLayer(layerToAdd);
                $ctrl.layer.addTo($ctrl.map);
                $ctrl.map.fitBounds($ctrl.layer.getBounds());
            }

            if (markers.length === 0
                    && lines.length === 0 && multiLines.length === 0
                    && polygons.length === 0 && multiPolygons.length === 0) {
                // when we don't have any marker or line or polygon, we set the view on the default geolocation
                service.setDefaultCenterView($ctrl.map);
            }
        }
        // TG-3473-VSN - add/remove marker to selection and change its color accordingly
        selectMarker(siteID, marker) {
            var $ctrl = this;
            // If already selected, unselect and vice versa
            if ($ctrl.markerBySiteId[siteID].isSelected) {
                marker.setIcon($ctrl.blueIcon);
                $ctrl.markerBySiteId[siteID].isSelected = false;
                $ctrl.selectedMarkersList = $ctrl.selectedMarkersList.filter((site) => site.id !== siteID);
                // Use collection function to set current item
                $ctrl.collection.setCurrent($ctrl.selectedMarkersList[0] ? $ctrl.selectedMarkersList[0].id : null)

                // Send signal of updated markers - case of deselection
                $ctrl.$scope.$emit('markerIsSelected', $ctrl.selectedMarkersList);
                $ctrl.parentScope.isResearchOn.on = false;
            } else {
                marker.setIcon($ctrl.orangeIcon);
                $ctrl.markerBySiteId[siteID].isSelected = true;
                var filter = {};
                filter.fields = [
                    'custom_fields'
                ];
                $ctrl.swif.data.addFilter(filter, 'id', '=', siteID);
                $ctrl.swif.data.searchRead('patrimoine_site', filter).then(function(data) {
                    $ctrl.allSites.find((site) => site.id == siteID)['custom_fields'] = data.records[0].custom_fields
                    $ctrl.selectedMarkersList.push($ctrl.allSites.find((site) => site.id == siteID));
                    // Use collection function to set current item
                    $ctrl.collection.setCurrent(siteID)
                    // Send signal of updated markers list to global scope
                    $ctrl.$scope.$emit('markerIsSelected', $ctrl.selectedMarkersList);
                    $ctrl.parentScope.isResearchOn.on = false;
                });
            }
        }
        // TG-3473-VSN - add/remove marker to selection and change its color accordingly
        selectLine(siteID, polygon) {
            var $ctrl = this;
            // If already selected, unselect and vice versa
            if ($ctrl.markerBySiteId[siteID].isSelected) {
                polygon.setStyle({color: 'blue'});
                $ctrl.markerBySiteId[siteID].isSelected = false;
                $ctrl.selectedMarkersList = $ctrl.selectedMarkersList.filter((site) => site.id !== siteID);
                // Use collection function to set current item
                this.collection.setCurrent($ctrl.selectedMarkersList[0] ? $ctrl.selectedMarkersList[0].id : null)
                // Send signal of updated markers - case of deselection
                $ctrl.$scope.$emit('markerIsSelected', $ctrl.selectedMarkersList);
                $ctrl.parentScope.isResearchOn.on = false;
            } else {
                polygon.setStyle({color: 'orange'});
                $ctrl.markerBySiteId[siteID].isSelected = true;
                var filter = {};
                filter.fields = [
                    'custom_fields'
                ];
                $ctrl.swif.data.addFilter(filter, 'id', '=', siteID);
                $ctrl.swif.data.searchRead('patrimoine_site', filter).then(function(data) {
                    $ctrl.allSites.find((site) => site.id == siteID)['custom_fields'] = data.records[0].custom_fields
                    $ctrl.selectedMarkersList.push($ctrl.allSites.find((site) => site.id == siteID));
                    // Use collection function to set current item
                    $ctrl.collection.setCurrent(siteID)
                    // Send signal of updated markers list to global scope
                    $ctrl.$scope.$emit('markerIsSelected', $ctrl.selectedMarkersList);
                    $ctrl.parentScope.isResearchOn.on = false;
                });
            }
        }
        selectPolygon(site) {
            var $ctrl = this;
            $ctrl.$scope.$emit('markerIsSelected', [site]);

        }
        // TG-3474-VSN - trigger default layer
        initDefault() {
            if (this.defaultOption.isLayer.length > 0) {
                this.getSitesLayer(this.defaultOption.isLayer[0].id, 'is_layer');
                this.selectedLayer = [this.defaultOption.isLayer[0].id, this.defaultOption.isLayer[0].name]
            }
        };
        // TG-3474-VSN - get all site_categories
        getAllSiteCategories(layerType) {
            var $ctrl = this;
            var filter = {};
            $ctrl.defaultOption = {};
            filter.limit = 0;
            filter.fields = ['id', 'name'];
            $ctrl.swif.data.sortOn(filter, 'name');
            $ctrl.swif.data.addFilter(filter, layerType, '=', true);
            return $ctrl.swif.data.searchRead('site_category', filter)
            .then(function(data) {
                // Set default layer (later: Orthophoto Enedis 2016)
                if (layerType == 'is_layer') {
                    $ctrl.defaultOption.isLayer = data.records.filter((category) => category.name == 'default');
                    $ctrl.initDefault();
                }
                return data.records;
            });
        }
        // TG-3474-VSN - get all sites from a site_category
        getSitesLayer(typeId, currentLayer) {
            var $ctrl = this;
            var filter = {};
            var fieldToSearch;
            filter.limit = 0;
            filter.fields = [
                'geo_point',
                'geo_multi_point',
                'geo_line',
                'geo_multi_line',
                'geo_polygon',
                'geo_multi_polygon',
                'state',
                'name',
                'street',
                'street2',
                'zip',
                'city',
                'type_id',
                'service_names',
                'site1',
                'swif_id'
            ];
            // Search in type_id if "layer" chosen, search in type_ids if "family" chosen
            $ctrl.currentLayer = currentLayer;
            fieldToSearch = $ctrl.currentLayer == 'is_layer' ? 'type_id' : 'type_ids';
            $ctrl.swif.data.addFilter(filter, fieldToSearch, '=', typeId);
            $ctrl.swif.data.searchRead('patrimoine_site', filter)
            .then(function(data) {
                $ctrl.allSites = data.records;
                $ctrl.updateMarkers();
            });
        }
        // TG-3474-VSN
        clearSelection(layerType) {
            this.allSites = [];
            this.updateMarkers();

            let typeId
            if (layerType === 'is_layer') {
                typeId = this.selectedLayer ? this.selectedLayer[0] : 0
            } else {
                typeId = this.selectedFamily ? this.selectedFamily[0] : 0
            }

            this.getSitesLayer(typeId, layerType)
        }
    }
    SiteExplorerLeafletCtrl.$inject = ['$scope', 'swifRouteService', 'dataService', 'swifCartoLeafletService', '$rootScope', 'swifFrameworkService', 'swifPatrimoineReferentielService'];

    angular.module('swif.carto')

    .component('siteExplorerLeaflet', {
        template: `
        <div ng-if="$ctrl.showLeaflet" class="widemap">
            <div class="row" ng-show="$ctrl.isVSN" ng-init="layer='is_layer'">
                <div class="form-group col-sm-3 col-md-3">
                    <label class="align-middle">
                        <input type="radio" value="is_layer"
                            ng-model="layer"
                            ng-change="$ctrl.clearSelection('is_layer')"
                        >
                            Couche
                        <span class="badge progress-bar-info"><span>{{ ($ctrl.currentLayer == 'is_layer') ? $ctrl.allSites.length : 0 }}</span></span>
                    </label>
                    <swif-input-select-one
                        ng-checked="!isResearchOn.on"
                        ng-show="layer == 'is_layer'"
                        ng-model="$ctrl.selectedLayer"
                        choices="$ctrl.allLayerCategories"
                        swif-change="$ctrl.getSitesLayer($value.id, layer)"
                        swif-placeholder="-- Choisir une couche --">
                    </swif-input-select-one>
                </div>
                <div class="form-group col-sm-3 col-md-3">
                    <label>
                        <input type="radio" value="is_family"
                            ng-model="layer"
                            ng-change="$ctrl.clearSelection('is_family')"
                        >
                            Famille
                        <span class="badge progress-bar-info"><span>{{ ($ctrl.currentLayer == 'is_family') ? $ctrl.allSites.length : 0}}</span></span>
                    </label>
                    <swif-input-select-one
                        ng-show="layer == 'is_family'"
                        ng-model="$ctrl.selectedFamily"
                        choices="$ctrl.allFamilyCategories"
                        swif-change="$ctrl.getSitesLayer($value.id, layer)"
                        ng-disabled="readonly"
                        swif-placeholder="-- Choisir une famille --">
                    </swif-input-select-one>
                </div>
            </div>
            <swif-leaflet on-map-initialized="$ctrl._onMapInitialized(map)">
            </swif-leaflet>
        </div>`,
        controller: SiteExplorerLeafletCtrl,
        bindings: {
            collection: '<'
        }
    });


})();
